(function() {
    angular
        .module("app")
        .factory("queryStringService", queryStringService)

    queryStringService.$inject = []

    function queryStringService() {
        var service = {}

        /**
            Create query string
            @param formData
            @param inputArray
            @returns {string}
         **/
        service.createQueryString = function(formData, inputArray) {
            var query = ""
            var count = 0
            angular.forEach(formData, function(value, key) {
                if (value == null) {
                    value = ""
                }
                query += inputArray + "[" + key + "]=" + value
                count++
                if (count < Object.keys(formData).length) {
                    query += "&"
                }
            })

            return query
        }

        /**
            Create query string from array
            @param array
            @param inputArray
            @returns {string}
         **/
        service.createQueryStringFromArray = function(array, inputArray) {
            var query = ""
            var count = 0
            angular.forEach(array, function(value, key) {
                if (value == null) {
                    value = ""
                }
                query += inputArray + "[]=" + value
                count++
                if (count < Object.keys(array).length) {
                    query += "&"
                }
            })

            return query
        }

        /**
            Create query json
            @param formData
            @param inputArray
            @returns {string}
         **/
        service.createQueryJson = function(formData, inputArray) {
            var query = {}
            query[inputArray] = {}

            angular.forEach(formData, function(value, key) {
                if (value == null) {
                    value = ""
                }
                query[inputArray][key] = value
            })

            return query
        }

        /**
            Extract customer ID
            @param {int} customerID
            @returns {string}
         **/
        service.extractCustomerID = function(customerID) {
            var query = ""

            if(customerID) {
                query = "&customer_id=" + customerID
            }

            return query
        }

        /**
            @param paginationData
            @returns {string}
         **/
        service.createPaginationString = function(paginationData) {
            var paginationQuery = "perPage=100&page=1"

            if (paginationData) {
                paginationQuery = "perpage=" + paginationData.perPage
                    + "&page=" + paginationData.page
                    + "&sort=" + paginationData.sortBy
                    + "&sort_direction=" + paginationData.sortDirection
            }

            return paginationQuery
        }


        return service
    }
})()
